export default function formatPrice(price) {
  return `$${Number(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    .replace('.00', '')}`;
}
